import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'
import { AddSiteDialog } from '@/components/add-site-dialog'
import { EmptyState } from '@/components/empty-state'
import { Button } from '@/components/ui/button'
import { sitesQuery } from '@/lib/queries'
import { SiteList, SiteListSkeleton } from './-site-list'

export const Route = createFileRoute('/_app/$org/sites')({
  loader: ({ context }) => context.queryClient.ensureQueryData(sitesQuery),
  component: SitesPage,
})

function SitesPage() {
  const { org } = Route.useParams()
  const { data, isPending } = useQuery(sitesQuery)
  const sites = data?.sites ?? []

  return (
    <>
      {/* No title: the tab row already says which page this is, and no other
          report carries one. The row survives for the action alone. */}
      <h1 className="sr-only">Sites</h1>
      {sites.length > 0 && (
        <div className="mb-4 flex items-center justify-end">
          <AddSiteDialog
            trigger={
              <Button size="sm">
                <PlusIcon />
                Add site
              </Button>
            }
          />
        </div>
      )}

      {isPending ? (
        <SiteListSkeleton />
      ) : sites.length === 0 ? (
        <div className="rounded-lg border border-border bg-card">
          <EmptyState
            title="No sites yet"
            description="Add the domain you want to track. Connecting Search Console comes next, and is what makes the data useful."
            action={
              <AddSiteDialog
                trigger={
                  <Button size="sm">
                    <PlusIcon />
                    Add site
                  </Button>
                }
              />
            }
          />
        </div>
      ) : (
        <SiteList org={org} sites={sites} />
      )}
    </>
  )
}
